// extracted by css-extract-rspack-plugin
export default {"cell-title":"fhgfg7","cellTitle":"fhgfg7","controls":"fBmZ0i"};